module.exports = __webpack_public_path__ + "static/media/placeholder.f771455e.jpg";